var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageSizes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#5d78ff",
    d: "M9.683,10.683,5.416,6.416A.833.833,0,1,1,6.594,5.237L10.862,9.5l5.16-5.16A.833.833,0,0,1,17.2,5.523l-5.16,5.16,5.16,5.16a.833.833,0,0,1-1.179,1.179l-5.16-5.16L6.594,16.13a.833.833,0,1,1-1.179-1.179Z",
    transform: "translate(-0.862 -0.683)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M5.667,15.667h2.5Q9,15.81,9,16.5t-.833.833H4V13.167a.737.737,0,0,1,.833-.833.737.737,0,0,1,.833.833Zm10,0v-2.5q.143-.833.833-.833t.833.833v4.167H13.167a.737.737,0,0,1-.833-.833.737.737,0,0,1,.833-.833Zm0-10h-2.5q-.833-.143-.833-.833T13.167,4h4.167V8.167A.737.737,0,0,1,16.5,9a.737.737,0,0,1-.833-.833Zm-10,0v2.5Q5.524,9,4.833,9T4,8.167V4H8.167A.737.737,0,0,1,9,4.833a.737.737,0,0,1-.833.833Z",
    transform: "translate(-0.667 -0.667)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageSizes);
export default __webpack_public_path__ + "static/media/package_sizes.0d2c635713cdb218b913bfa73d8045b8.svg";
export { ForwardRef as ReactComponent };